<template>
  <div>
    <p class="text-h6 text-md-h4 text-center mb-0 pa-4">О клубе Кубит</p>

    <v-carousel v-model="model">
      <v-carousel-item
        :src="getImgUrl(item.src)"
        v-for="(item, i) in slide"
        :key="i"
      >
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-md-h4 text-h6">
            {{ item.text }}
          </div>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  data: () => ({
    model: 0,
    slide: [
      {
        src: "q7.jpg",
        text: "Современное оборудование",
      },
      {
        src: "q3.jpg",
        text: "Топовые преподаватели",
      },
      {
        src: "q10.jpg",
        text: "Свободная обстановка",
      },
      {
        src: "q2.jpg",
        text: "Новые друзья",
      },
      {
        src: "q11.jpg",
        text: "Ответы на вопросы",
      },
    ],
  }),
  methods: {
    getImgUrl(pic) {
      return require("../../assets/images/" + pic);
    },
  },
};
</script>

<style>
</style>